var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoresult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.72,
    y: 110.24,
    width: 272,
    height: 207.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.4,213.23a86.66,86.66,0,0,0-9.11,7.47c-5.6,5.14-14.94,12.61-15.41,14.25s6.31,32.22,8.88,42,3.27,54.87,0,70.28a186,186,0,0,1-8.64,28.49,40.18,40.18,0,0,0,24.51,7c14.48-.71,21-4.67,28.26-4s15.41.46,19.15-4.44,7.7-6.77,10-9.81a11.83,11.83,0,0,0,2.33-6.54s-2.1-7.94-9.81-32.92-7.7-58.38-9.1-65.38-4.67-28.25-7.94-34.09S147,215.33,140.44,214.17,132.74,212.06,130.4,213.23Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.61,206.85s2.49,5.23,2.73,8.44,8.09,14.86,10.82,14.86,2.62-8.8,2.26-12.72.71-6.07,1.07-6.54-5-1.9-8.32-4.4-6.07-2.86-7.38-2.38S125.61,206.85,125.61,206.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.06,187.82s1.9,4.16,3.68,5.83,3.33,1.3,2.74,2.61-3.21,3-3.21,3,.24,5.94,0,8.79,0,3.69-2.62,4.17A22.5,22.5,0,0,1,136,211a9.81,9.81,0,0,1-5.47-4.4,11.81,11.81,0,0,1-3.33-.36c-2.26-.47-4.16-5.23-2.85-7a3.48,3.48,0,0,1,4.87-.6c.84,1,1.79,1.9,2.5,1.9s2.14-.59,1.31-2.14-1.79-2.85-.48-3.92S143.92,187.7,146.06,187.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,212.55a51,51,0,0,1,9.52-13.31c6.54-6.66,31-13.56,32.34-15.46s-11.3,1.19-11.3,1.19-7.37-8.92-18.07-9.52-13.79,11.06-13.91,16.89,2.85,12.6,2.85,12.6S114.07,213.5,116,212.55Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.07,247.32S74.13,259.7,73.89,260.63s37.83,36.2,37.83,36.2l7-7.71L97.94,261.33l15.88-10s1.4-7.7-.93-12.14a10.28,10.28,0,0,0-7-5.14Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.45,246.82s-14.57-8.3-20.61-14.2-8.54-8.67-9.17-6.41,5.28,32,6.41,32.54,25,9.05,29.78,9.3,8,.63,8.55-1.5-3-8.67-7.42-13.83S193.45,246.82,193.45,246.82Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.13,216.27s6.54,20.08,9.34,33.86,4,26.61,4,26.61-4-2.56-14.71-3.5-15.64-2.57-20.31-11.44-7.71-8.17-12.38-9.57-6.07-4-6.07-4S125.5,216,127.13,216.27Zm14.8-1.75a126.47,126.47,0,0,1,8.42,21.62c3.64,12.56,8.8,40,8.8,40s8.92-1,11.56-6.66,2.76-7.8,7-9.3,10.06-4.65,10.56-8.67a63.2,63.2,0,0,1,1.63-8.05s-23.49-19.47-27.14-22S142.94,213.52,141.93,214.52Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.07,255.49l-12.94-27.14,9.55-5s10.18,11.81,14.33,20,6,21.24,4.4,23.25-8.93.62-12.57-1.64",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458,432.74c0,2.53-90,4.59-201,4.59s-201-2.06-201-4.59,90-4.59,201-4.59S458,430.2,458,432.74Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,432.74c0,2.53-90,4.59-201,4.59s-201-2.06-201-4.59,90-4.59,201-4.59S458,430.2,458,432.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.68,272.91c-.06,0,.67-3.62.74-3.85.84-2.58,4-7.09,7-7.08a3.6,3.6,0,0,1,3.46,4.09c-.22,2.14-2.14,4-3.88,5C391,272.32,385.68,272.91,385.68,272.91Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,248.52c2.87,1,4.29,6.33,4.2,9,0,.23-.55,3.89-.6,3.87l-.06,0c.24.83.47,1.73.71,2.72.43,1.82.9,3.89,1.26,6.17a62.35,62.35,0,0,1,.81,7.43,46.42,46.42,0,0,1-.28,8.35.44.44,0,0,1,0,.1c.38-.81,1.5-3,1.61-3.2,1.49-2.28,5.71-5.79,8.64-5a3.6,3.6,0,0,1,2.26,4.86c-.77,2-3.11,3.26-5.06,3.81-2.2.63-7.11-.11-7.5-.17a64.78,64.78,0,0,1-1.81,8.31c-.45,1.59-.95,3.18-1.48,4.77.35-.69.66-1.3.72-1.38,1.49-2.27,5.71-5.79,8.64-5a3.6,3.6,0,0,1,2.26,4.86c-.78,2-3.11,3.26-5.06,3.81s-6.18,0-7.29-.14l-.62,1.82c-1,2.91-2,5.81-2.93,8.68-.32,1-.6,2-.88,3,.3-.61.57-1.13.62-1.2,1.49-2.27,5.71-5.79,8.64-5a3.6,3.6,0,0,1,2.26,4.86c-.78,2-3.11,3.26-5.06,3.81s-5.77.07-7.09-.11c-.26,1-.52,2.08-.72,3.1-.13.7-.29,1.37-.38,2.08s-.2,1.39-.29,2.08c-.14,1.33-.29,2.7-.39,4-.08.91-.14,1.77-.2,2.64.31-1,1-3,1-3.13a14,14,0,0,1,4.66-5.31,4.7,4.7,0,0,1,.39-.69,3.6,3.6,0,0,1,5.3-.83c2.3,2,1.73,7.45.67,9.95-.06.15-.92,1.68-1.48,2.63.41-.51.81-1,1.24-1.53.85-1,1.72-2,2.66-3.13l1.42-1.55c.47-.53,1-1,1.54-1.54,1.22-1.18,2.51-2.31,3.84-3.43-.91-.74-4.09-3.42-5-5.25s-1.56-4.38-.61-6.3a3.59,3.59,0,0,1,5.11-1.62c2.58,1.61,2.84,7.1,2.17,9.73,0,.17-.73,2-1.13,3,.8-.67,1.6-1.33,2.43-2,2.41-1.86,4.9-3.66,7.38-5.48.76-.55,1.51-1.12,2.27-1.68-.33-.26-4.18-3.37-5.2-5.41-.91-1.81-1.56-4.38-.61-6.31a3.61,3.61,0,0,1,5.11-1.62c2.58,1.62,2.84,7.11,2.17,9.74-.05.2-1.05,2.84-1.34,3.5,1.66-1.23,3.3-2.48,4.87-3.77a64.89,64.89,0,0,0,6-5.61c-.16-.12-4.18-3.35-5.23-5.44-.91-1.82-1.57-4.38-.61-6.31a3.61,3.61,0,0,1,5.11-1.62c2.58,1.62,2.83,7.1,2.17,9.74-.05.17-.81,2.19-1.19,3.14l.15.09a47.15,47.15,0,0,0,4.94-6.64c.81-1.29,1.52-2.56,2.18-3.82-.82-.52-4.5-3-5.65-4.74s-2-4.18-1.3-6.2a3.6,3.6,0,0,1,4.9-2.17c2.74,1.33,3.6,6.75,3.23,9.44,0,.15-.4,1.61-.68,2.68.29-.57.59-1.16.86-1.71,1-2.07,1.79-4,2.48-5.78.38-1,.7-1.9,1-2.75-.53-.93-2.61-4.7-2.81-6.77s.12-4.65,1.7-6.1a3.59,3.59,0,0,1,5.35.33c1.83,2.44.09,7.64-1.48,9.86-.14.19-2.61,2.95-2.64,2.9l0-.06c-.27.83-.57,1.71-.91,2.66-.65,1.76-1.4,3.75-2.36,5.85a63.88,63.88,0,0,1-3.42,6.64,46.49,46.49,0,0,1-4.84,6.8l-.07.08c.76-.47,2.93-1.71,3.11-1.78,2.49-1.08,7.95-1.68,9.95.61a3.6,3.6,0,0,1-.79,5.3c-1.76,1.25-4.39,1-6.33.39-2.18-.69-5.87-4-6.16-4.29a63.61,63.61,0,0,1-6.1,5.94c-1.25,1.08-2.55,2.13-3.86,3.17.67-.39,1.27-.73,1.36-.76,2.5-1.08,8-1.68,10,.61a3.6,3.6,0,0,1-.8,5.3c-1.76,1.25-4.39,1-6.33.39s-5.16-3.4-6-4.14L407,316c-2.44,1.87-4.89,3.72-7.23,5.62-.83.67-1.62,1.35-2.41,2l1.18-.66c2.5-1.07,8-1.68,10,.62a3.6,3.6,0,0,1-.8,5.3c-1.75,1.24-4.39,1-6.32.38s-4.86-3.12-5.85-4c-.79.72-1.59,1.45-2.32,2.19-.49.51-1,1-1.46,1.52l-1.39,1.58c-.85,1-1.73,2.09-2.53,3.12-.57.71-1.09,1.4-1.62,2.09.81-.67,2.44-1.95,2.58-2,2.31-1.44,7.61-2.86,9.94-.9a3.61,3.61,0,0,1,0,5.37c-1.54,1.49-4.18,1.65-6.19,1.33-2.21-.34-6.21-2.95-6.71-3.27-.87,1.14-1.71,2.27-2.48,3.34-2.69,3.72-4.79,6.92-6.23,9.18l-.14.23-1.86-.9c.09-.15.19-.29.29-.45,1.5-2.25,3.69-5.43,6.49-9.13.88-1.17,1.85-2.4,2.85-3.66a36.83,36.83,0,0,1-2.89-3.58c-2.14.84-6.59.88-7.17.88-.09,1.44-.17,2.84-.22,4.16-.2,4.59-.18,8.41-.14,11.09,0,.11,0,.21,0,.31l-2.05-1c0-2.66.1-6.25.37-10.5.09-1.47.22-3,.36-4.63-.56-.14-5.2-1.33-6.94-2.73s-3.26-3.32-3.2-5.47a3.6,3.6,0,0,1,4-3.61c3,.39,5.55,5.26,6.05,7.93,0,.16.16,1.91.22,3,.06-.65.11-1.29.18-2,.14-1.33.31-2.66.49-4.08.11-.69.23-1.38.34-2.08s.29-1.42.43-2.13c.37-1.66.82-3.31,1.31-5-1.16-.12-5.29-.61-7.06-1.63s-3.72-2.79-4-4.92a3.6,3.6,0,0,1,3.37-4.17c3-.07,6.28,4.36,7.18,6.92.06.16.49,2.08.71,3.13.3-1,.6-2,.94-3,1-2.88,2.07-5.77,3.13-8.65.33-.88.65-1.77,1-2.65-.42,0-5.34-.51-7.32-1.65-1.76-1-3.72-2.79-4-4.92a3.6,3.6,0,0,1,3.37-4.17c3-.08,6.28,4.36,7.18,6.92.07.2.69,2.95.81,3.66.71-1.94,1.39-3.89,2-5.83a61.5,61.5,0,0,0,1.93-8c-.19,0-5.33-.49-7.36-1.66-1.76-1-3.72-2.79-4-4.92a3.6,3.6,0,0,1,3.37-4.17c3.05-.07,6.29,4.36,7.18,6.92.06.17.54,2.27.74,3.27h.18a46.91,46.91,0,0,0,.46-8.26c0-1.52-.15-3-.29-4.39-1,0-5.38,0-7.33-.83s-4-2.37-4.5-4.46a3.6,3.6,0,0,1,2.89-4.51c3-.41,6.72,3.64,7.9,6.09.06.13.56,1.56.91,2.61-.08-.64-.14-1.3-.23-1.9-.31-2.29-.73-4.36-1.12-6.19-.23-1-.46-2-.68-2.84-1-.49-4.77-2.49-6.08-4.1s-2.46-4-1.95-6A3.61,3.61,0,0,1,379.78,248.52Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.82,295.45c-2.38-.1-7.14-2.54-7.14-2.54s2.56-2.65,2.74-2.79c2.13-1.7,7.23-3.72,9.77-2a3.62,3.62,0,0,1,.63,5.33C439.45,295.07,436.85,295.53,434.82,295.45Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.68,272.91c-.06,0,.67-3.62.74-3.85.84-2.58,4-7.09,7-7.08a3.6,3.6,0,0,1,3.46,4.09c-.22,2.14-2.14,4-3.88,5C391,272.32,385.68,272.91,385.68,272.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,248.52c2.87,1,4.29,6.33,4.2,9,0,.23-.55,3.89-.6,3.87l-.06,0c.24.83.47,1.73.71,2.72.43,1.82.9,3.89,1.26,6.17a62.35,62.35,0,0,1,.81,7.43,46.42,46.42,0,0,1-.28,8.35.44.44,0,0,1,0,.1c.38-.81,1.5-3,1.61-3.2,1.49-2.28,5.71-5.79,8.64-5a3.6,3.6,0,0,1,2.26,4.86c-.77,2-3.11,3.26-5.06,3.81-2.2.63-7.11-.11-7.5-.17a64.78,64.78,0,0,1-1.81,8.31c-.45,1.59-.95,3.18-1.48,4.77.35-.69.66-1.3.72-1.38,1.49-2.27,5.71-5.79,8.64-5a3.6,3.6,0,0,1,2.26,4.86c-.78,2-3.11,3.26-5.06,3.81s-6.18,0-7.29-.14l-.62,1.82c-1,2.91-2,5.81-2.93,8.68-.32,1-.6,2-.88,3,.3-.61.57-1.13.62-1.2,1.49-2.27,5.71-5.79,8.64-5a3.6,3.6,0,0,1,2.26,4.86c-.78,2-3.11,3.26-5.06,3.81s-5.77.07-7.09-.11c-.26,1-.52,2.08-.72,3.1-.13.7-.29,1.37-.38,2.08s-.2,1.39-.29,2.08c-.14,1.33-.29,2.7-.39,4-.08.91-.14,1.77-.2,2.64.31-1,1-3,1-3.13a14,14,0,0,1,4.66-5.31,4.7,4.7,0,0,1,.39-.69,3.6,3.6,0,0,1,5.3-.83c2.3,2,1.73,7.45.67,9.95-.06.15-.92,1.68-1.48,2.63.41-.51.81-1,1.24-1.53.85-1,1.72-2,2.66-3.13l1.42-1.55c.47-.53,1-1,1.54-1.54,1.22-1.18,2.51-2.31,3.84-3.43-.91-.74-4.09-3.42-5-5.25s-1.56-4.38-.61-6.3a3.59,3.59,0,0,1,5.11-1.62c2.58,1.61,2.84,7.1,2.17,9.73,0,.17-.73,2-1.13,3,.8-.67,1.6-1.33,2.43-2,2.41-1.86,4.9-3.66,7.38-5.48.76-.55,1.51-1.12,2.27-1.68-.33-.26-4.18-3.37-5.2-5.41-.91-1.81-1.56-4.38-.61-6.31a3.61,3.61,0,0,1,5.11-1.62c2.58,1.62,2.84,7.11,2.17,9.74-.05.2-1.05,2.84-1.34,3.5,1.66-1.23,3.3-2.48,4.87-3.77a64.89,64.89,0,0,0,6-5.61c-.16-.12-4.18-3.35-5.23-5.44-.91-1.82-1.57-4.38-.61-6.31a3.61,3.61,0,0,1,5.11-1.62c2.58,1.62,2.83,7.1,2.17,9.74-.05.17-.81,2.19-1.19,3.14l.15.09a47.15,47.15,0,0,0,4.94-6.64c.81-1.29,1.52-2.56,2.18-3.82-.82-.52-4.5-3-5.65-4.74s-2-4.18-1.3-6.2a3.6,3.6,0,0,1,4.9-2.17c2.74,1.33,3.6,6.75,3.23,9.44,0,.15-.4,1.61-.68,2.68.29-.57.59-1.16.86-1.71,1-2.07,1.79-4,2.48-5.78.38-1,.7-1.9,1-2.75-.53-.93-2.61-4.7-2.81-6.77s.12-4.65,1.7-6.1a3.59,3.59,0,0,1,5.35.33c1.83,2.44.09,7.64-1.48,9.86-.14.19-2.61,2.95-2.64,2.9l0-.06c-.27.83-.57,1.71-.91,2.66-.65,1.76-1.4,3.75-2.36,5.85a63.88,63.88,0,0,1-3.42,6.64,46.49,46.49,0,0,1-4.84,6.8l-.07.08c.76-.47,2.93-1.71,3.11-1.78,2.49-1.08,7.95-1.68,9.95.61a3.6,3.6,0,0,1-.79,5.3c-1.76,1.25-4.39,1-6.33.39-2.18-.69-5.87-4-6.16-4.29a63.61,63.61,0,0,1-6.1,5.94c-1.25,1.08-2.55,2.13-3.86,3.17.67-.39,1.27-.73,1.36-.76,2.5-1.08,8-1.68,10,.61a3.6,3.6,0,0,1-.8,5.3c-1.76,1.25-4.39,1-6.33.39s-5.16-3.4-6-4.14L407,316c-2.44,1.87-4.89,3.72-7.23,5.62-.83.67-1.62,1.35-2.41,2l1.18-.66c2.5-1.07,8-1.68,10,.62a3.6,3.6,0,0,1-.8,5.3c-1.75,1.24-4.39,1-6.32.38s-4.86-3.12-5.85-4c-.79.72-1.59,1.45-2.32,2.19-.49.51-1,1-1.46,1.52l-1.39,1.58c-.85,1-1.73,2.09-2.53,3.12-.57.71-1.09,1.4-1.62,2.09.81-.67,2.44-1.95,2.58-2,2.31-1.44,7.61-2.86,9.94-.9a3.61,3.61,0,0,1,0,5.37c-1.54,1.49-4.18,1.65-6.19,1.33-2.21-.34-6.21-2.95-6.71-3.27-.87,1.14-1.71,2.27-2.48,3.34-2.69,3.72-4.79,6.92-6.23,9.18l-.14.23-1.86-.9c.09-.15.19-.29.29-.45,1.5-2.25,3.69-5.43,6.49-9.13.88-1.17,1.85-2.4,2.85-3.66a36.83,36.83,0,0,1-2.89-3.58c-2.14.84-6.59.88-7.17.88-.09,1.44-.17,2.84-.22,4.16-.2,4.59-.18,8.41-.14,11.09,0,.11,0,.21,0,.31l-2.05-1c0-2.66.1-6.25.37-10.5.09-1.47.22-3,.36-4.63-.56-.14-5.2-1.33-6.94-2.73s-3.26-3.32-3.2-5.47a3.6,3.6,0,0,1,4-3.61c3,.39,5.55,5.26,6.05,7.93,0,.16.16,1.91.22,3,.06-.65.11-1.29.18-2,.14-1.33.31-2.66.49-4.08.11-.69.23-1.38.34-2.08s.29-1.42.43-2.13c.37-1.66.82-3.31,1.31-5-1.16-.12-5.29-.61-7.06-1.63s-3.72-2.79-4-4.92a3.6,3.6,0,0,1,3.37-4.17c3-.07,6.28,4.36,7.18,6.92.06.16.49,2.08.71,3.13.3-1,.6-2,.94-3,1-2.88,2.07-5.77,3.13-8.65.33-.88.65-1.77,1-2.65-.42,0-5.34-.51-7.32-1.65-1.76-1-3.72-2.79-4-4.92a3.6,3.6,0,0,1,3.37-4.17c3-.08,6.28,4.36,7.18,6.92.07.2.69,2.95.81,3.66.71-1.94,1.39-3.89,2-5.83a61.5,61.5,0,0,0,1.93-8c-.19,0-5.33-.49-7.36-1.66-1.76-1-3.72-2.79-4-4.92a3.6,3.6,0,0,1,3.37-4.17c3.05-.07,6.29,4.36,7.18,6.92.06.17.54,2.27.74,3.27h.18a46.91,46.91,0,0,0,.46-8.26c0-1.52-.15-3-.29-4.39-1,0-5.38,0-7.33-.83s-4-2.37-4.5-4.46a3.6,3.6,0,0,1,2.89-4.51c3-.41,6.72,3.64,7.9,6.09.06.13.56,1.56.91,2.61-.08-.64-.14-1.3-.23-1.9-.31-2.29-.73-4.36-1.12-6.19-.23-1-.46-2-.68-2.84-1-.49-4.77-2.49-6.08-4.1s-2.46-4-1.95-6A3.61,3.61,0,0,1,379.78,248.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.82,295.45c-2.38-.1-7.14-2.54-7.14-2.54s2.56-2.65,2.74-2.79c2.13-1.7,7.23-3.72,9.77-2a3.62,3.62,0,0,1,.63,5.33C439.45,295.07,436.85,295.53,434.82,295.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407,355s-14.44-34.8-22.52-33.29,13.86,55.48,13.86,55.48S373,329.3,355.66,329.3s6.35,53,28.28,70.61c0,0-34.64-37.32-54.84-29.25s40.41,45.89,40.41,45.89-35.22-11.09-31.17-2.52,15,10.09,15,10.09l-39.84,2H452.07l-31.18-3s32.33-16.14,23.67-22.7S416.85,408,416.85,408s32.91-36.32,26.56-49.93-34.64,24.71-34.64,24.71,23.09-48.92,18.47-57.5S407,355,407,355Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,355s-14.44-34.8-22.52-33.29,13.86,55.48,13.86,55.48S373,329.3,355.66,329.3s6.35,53,28.28,70.61c0,0-34.64-37.32-54.84-29.25s40.41,45.89,40.41,45.89-35.22-11.09-31.17-2.52,15,10.09,15,10.09l-39.84,2H452.07l-31.18-3s32.33-16.14,23.67-22.7S416.85,408,416.85,408s32.91-36.32,26.56-49.93-34.64,24.71-34.64,24.71,23.09-48.92,18.47-57.5S407,355,407,355Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.66,356.86C399,394.38,399,420.94,399,420.94s15,.58,30.59-11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.31,377.06a225.24,225.24,0,0,0-10.4-32.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.78,355.12,400.11,403s21.94-18.47,29.44-28.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,414.59s-34.06-16.17-47.92-25.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "221.3 104.67 213.69 92.53 146.67 92.53 146.67 104.67 146.67 109.04 146.67 322.03 422.54 322.03 422.54 104.67 221.3 104.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.72,
    y: 110.24,
    width: 272,
    height: 207.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.74,
    y: 108.56,
    width: 6.31,
    height: 210.56,
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.74,
    y: 229.25,
    width: 6.31,
    height: 88.24,
    style: {
      opacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 107.58,
    width: 273.44,
    height: 22.22,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.81,
    y: 114.66,
    width: 113.59,
    height: 12.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 114.66,
    width: 17.84,
    height: 12.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.59,
    y: 114.66,
    width: 14.81,
    height: 12.68,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.44,
    cy: 119.76,
    r: 3.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.75,
    y1: 122.06,
    x2: 340.79,
    y2: 125.09,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.08,
    y: 149.17,
    width: 23.45,
    height: 23.45,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 152.71,
    x2: 274.3,
    y2: 152.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 159.78,
    x2: 295.1,
    y2: 159.78,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 163.99,
    x2: 311.91,
    y2: 163.99,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 157.13,
    width: 17.25,
    height: 7.52,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.36,
    y: 157.13,
    width: 17.25,
    height: 7.52,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.08,
    y: 182.35,
    width: 23.45,
    height: 23.45,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 185.89,
    x2: 274.3,
    y2: 185.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 192.97,
    x2: 295.1,
    y2: 192.97,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 197.17,
    x2: 311.91,
    y2: 197.17,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 190.31,
    width: 17.25,
    height: 7.52,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.36,
    y: 190.31,
    width: 17.25,
    height: 7.52,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.08,
    y: 215.53,
    width: 23.45,
    height: 23.45,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 219.07,
    x2: 274.3,
    y2: 219.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 226.15,
    x2: 295.1,
    y2: 226.15,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 230.35,
    x2: 311.91,
    y2: 230.35,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 223.49,
    width: 17.25,
    height: 7.52,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.36,
    y: 223.49,
    width: 17.25,
    height: 7.52,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.08,
    y: 248.71,
    width: 23.45,
    height: 23.45,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 252.25,
    x2: 274.3,
    y2: 252.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 259.33,
    x2: 295.1,
    y2: 259.33,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 263.53,
    x2: 311.91,
    y2: 263.53,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 256.67,
    width: 17.25,
    height: 7.52,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.36,
    y: 256.67,
    width: 17.25,
    height: 7.52,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.08,
    y: 281.89,
    width: 23.45,
    height: 23.45,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 285.43,
    x2: 274.3,
    y2: 285.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 292.51,
    x2: 295.1,
    y2: 292.51,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.28,
    y1: 296.71,
    x2: 311.91,
    y2: 296.71,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 289.85,
    width: 17.25,
    height: 7.52,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.36,
    y: 289.85,
    width: 17.25,
    height: 7.52,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.41,
    cy: 136.6,
    r: 2.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.96,
    y1: 138.14,
    x2: 234,
    y2: 140.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,139.47h-2.16l-.24.69a.81.81,0,0,1-.27.39.48.48,0,0,1-.35.12.76.76,0,0,1-.35-.11.44.44,0,0,1-.21-.31.81.81,0,0,1,0-.48l1.34-3.47a3.22,3.22,0,0,1,.23-.52,1.13,1.13,0,0,1,.28-.32.81.81,0,0,1,.29-.15,1.11,1.11,0,0,1,.66,0,.9.9,0,0,1,.29.15,1.13,1.13,0,0,1,.28.32,3.22,3.22,0,0,1,.23.52l1.34,3.47a1,1,0,0,1,0,.48.47.47,0,0,1-.21.31.76.76,0,0,1-.35.11.52.52,0,0,1-.36-.12.86.86,0,0,1-.26-.39Zm-1.08-3.06-.81,2.29H240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.58,140.49a1.05,1.05,0,0,1-.13-.59v-3.77a1.05,1.05,0,0,1,.13-.59.48.48,0,0,1,.43-.19.54.54,0,0,1,.46.19,1,1,0,0,1,.14.59v3.77a1,1,0,0,1-.14.59.54.54,0,0,1-.46.19A.48.48,0,0,1,242.58,140.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.69,140.49a1.05,1.05,0,0,1-.13-.59v-3.77a1.05,1.05,0,0,1,.13-.59.46.46,0,0,1,.42-.19.52.52,0,0,1,.46.19,1,1,0,0,1,.15.59v3.77a1,1,0,0,1-.15.59.52.52,0,0,1-.46.19A.46.46,0,0,1,244.69,140.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,140.48a.78.78,0,0,1-.19-.56v-3.87a.63.63,0,0,1,.24-.53.92.92,0,0,1,.59-.18h1.48a6.05,6.05,0,0,1,.63,0,2.66,2.66,0,0,1,.56.12,1.42,1.42,0,0,1,.46.23,1.19,1.19,0,0,1,.3.39,1.41,1.41,0,0,1,.11.57c0,.7-.39,1.12-1.18,1.25v0a2.21,2.21,0,0,1,.48.1.7.7,0,0,1,.31.22.88.88,0,0,1,.19.34,3.53,3.53,0,0,1,.1.51l.07.49a1.39,1.39,0,0,1-.09.82.54.54,0,0,1-.53.25.6.6,0,0,1-.5-.21,1.34,1.34,0,0,1-.21-.69l0-.48a1,1,0,0,0-.23-.6.84.84,0,0,0-.62-.19h-.76v1.41a.77.77,0,0,1-.19.57.64.64,0,0,1-.49.19A.62.62,0,0,1,249,140.48Zm1.74-2.84a2.41,2.41,0,0,0,.4,0,1.69,1.69,0,0,0,.35-.1.64.64,0,0,0,.27-.22.74.74,0,0,0,.09-.38,1,1,0,0,0,0-.26.93.93,0,0,0-.09-.2.49.49,0,0,0-.15-.13l-.18-.08a.87.87,0,0,0-.21,0l-.23,0h-.82v1.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,140.52a1.66,1.66,0,0,1-.7-.64,2.08,2.08,0,0,1-.26-1.06,2,2,0,0,1,.24-1,1.78,1.78,0,0,1,.68-.68,2,2,0,0,1,1-.25,2.1,2.1,0,0,1,.79.14,1.32,1.32,0,0,1,.54.4,1.89,1.89,0,0,1,.3.56,2.94,2.94,0,0,1,.1.69c0,.2-.13.3-.37.3H255a.84.84,0,0,0,1,.9,1.24,1.24,0,0,0,.5-.1,1.73,1.73,0,0,0,.42-.25.27.27,0,0,1,.3,0,.4.4,0,0,1,.22.28.3.3,0,0,1-.08.34,2,2,0,0,1-.24.19,2.24,2.24,0,0,1-.29.17,1.46,1.46,0,0,1-.43.15,3,3,0,0,1-.54,0A2.38,2.38,0,0,1,254.8,140.52Zm1.72-2a1.25,1.25,0,0,0-.19-.65.6.6,0,0,0-.54-.23.68.68,0,0,0-.56.24,1.1,1.1,0,0,0-.23.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.23,140.28a.32.32,0,0,1-.13-.18.37.37,0,0,1,0-.21.52.52,0,0,1,.11-.19.31.31,0,0,1,.19-.09.42.42,0,0,1,.25.06.81.81,0,0,1,.14.07l.19.1.24.08a1.65,1.65,0,0,0,.32,0h.24l.25-.05a.39.39,0,0,0,.19-.1.3.3,0,0,0,.08-.2.24.24,0,0,0-.12-.19.73.73,0,0,0-.32-.14l-.51-.14-.45-.14a2.17,2.17,0,0,1-.35-.15.75.75,0,0,1-.27-.21.87.87,0,0,1-.15-.27,1.14,1.14,0,0,1-.06-.39,1,1,0,0,1,.47-.83,2,2,0,0,1,1.23-.24,2,2,0,0,1,.43.05l.3.09.28.12a.39.39,0,0,1,.19.17.33.33,0,0,1,0,.21.48.48,0,0,1-.07.2.25.25,0,0,1-.17.12.48.48,0,0,1-.26,0,3.08,3.08,0,0,0-.74-.18h-.28a.6.6,0,0,0-.27.07.19.19,0,0,0-.13.18.26.26,0,0,0,.1.2,1,1,0,0,0,.32.13l.51.12a5,5,0,0,1,.51.17,1.28,1.28,0,0,1,.38.21.75.75,0,0,1,.25.31,1,1,0,0,1,.09.44,1.07,1.07,0,0,1-.21.69,1.25,1.25,0,0,1-.58.42,2.26,2.26,0,0,1-.84.1A2.45,2.45,0,0,1,258.23,140.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.21,140.35a1.43,1.43,0,0,1-.38-1v-1.54a1,1,0,0,1,.15-.59.52.52,0,0,1,.46-.19.48.48,0,0,1,.43.19,1.05,1.05,0,0,1,.13.59v1.52a.72.72,0,0,0,.17.5.54.54,0,0,0,.43.17.68.68,0,0,0,.53-.23.82.82,0,0,0,.22-.59v-1.37a1.07,1.07,0,0,1,.14-.59A.54.54,0,0,1,265,137a.47.47,0,0,1,.43.19,1,1,0,0,1,.14.59v2.28a.69.69,0,0,1-.15.48.58.58,0,0,1-.45.15c-.38,0-.57-.21-.57-.64v0a1.22,1.22,0,0,1-.45.56,1.43,1.43,0,0,1-.76.18A1.27,1.27,0,0,1,262.21,140.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,140.49a1.05,1.05,0,0,1-.13-.59v-3.77a1.05,1.05,0,0,1,.13-.59.46.46,0,0,1,.42-.19.56.56,0,0,1,.47.19,1,1,0,0,1,.14.59v3.77a1,1,0,0,1-.14.59.56.56,0,0,1-.47.19A.46.46,0,0,1,266.59,140.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.06,140.4a1.55,1.55,0,0,1-.3-1.07v-1.56h-.23a.4.4,0,0,1-.3-.1.42.42,0,0,1-.1-.32.34.34,0,0,1,.39-.39h.32l.08-.72c0-.45.23-.67.55-.67s.46.24.46.74V137h.45c.25,0,.38.14.38.41a.35.35,0,0,1-.4.4h-.43v1.31a1.4,1.4,0,0,0,.11.65.4.4,0,0,0,.4.16h.22a.28.28,0,0,1,.18.06.36.36,0,0,1,.11.16,1.49,1.49,0,0,1,0,.21.36.36,0,0,1-.06.2.29.29,0,0,1-.15.12,2.5,2.5,0,0,1-.85.1A1.16,1.16,0,0,1,269.06,140.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.56,140.28a.38.38,0,0,1-.13-.18.37.37,0,0,1,0-.21.52.52,0,0,1,.11-.19.31.31,0,0,1,.19-.09.4.4,0,0,1,.25.06l.14.07.19.1.24.08a1.65,1.65,0,0,0,.32,0h.25l.24-.05a.39.39,0,0,0,.19-.1.25.25,0,0,0,0-.39.84.84,0,0,0-.33-.14l-.5-.14-.46-.14a2.63,2.63,0,0,1-.35-.15.75.75,0,0,1-.27-.21.87.87,0,0,1-.15-.27,1.15,1.15,0,0,1,0-.39.94.94,0,0,1,.46-.83,2,2,0,0,1,1.24-.24,1.86,1.86,0,0,1,.42.05l.31.09.27.12a.39.39,0,0,1,.19.17.33.33,0,0,1,.05.21.47.47,0,0,1-.06.2.29.29,0,0,1-.18.12.44.44,0,0,1-.25,0,3.16,3.16,0,0,0-.75-.18h-.28a.6.6,0,0,0-.27.07.19.19,0,0,0-.12.18.23.23,0,0,0,.1.2.9.9,0,0,0,.32.13l.5.12a4.55,4.55,0,0,1,.52.17,1.36,1.36,0,0,1,.37.21.86.86,0,0,1,.26.31,1.15,1.15,0,0,1,.08.44,1,1,0,0,1-.21.69,1.2,1.2,0,0,1-.58.42,2.21,2.21,0,0,1-.84.1A2.48,2.48,0,0,1,271.56,140.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.8,
    y1: 143.76,
    x2: 358.61,
    y2: 143.76,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.04,
    y1: 131.76,
    x2: 220.04,
    y2: 305.95,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.14,
    y1: 131.76,
    x2: 364.14,
    y2: 305.95,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.24,
    y1: 143.43,
    x2: 159.33,
    y2: 143.43,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 159.78,
    x2: 195.43,
    y2: 159.78,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 163.99,
    x2: 207.94,
    y2: 163.99,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 180.51,
    x2: 195.43,
    y2: 180.51,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 184.72,
    x2: 207.94,
    y2: 184.72,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 201.24,
    x2: 195.43,
    y2: 201.24,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 205.45,
    x2: 207.94,
    y2: 205.45,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 221.97,
    x2: 195.43,
    y2: 221.97,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 226.18,
    x2: 207.94,
    y2: 226.18,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 242.7,
    x2: 195.43,
    y2: 242.7,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 246.91,
    x2: 207.94,
    y2: 246.91,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 263.43,
    x2: 195.43,
    y2: 263.43,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 267.64,
    x2: 207.94,
    y2: 267.64,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 284.16,
    x2: 195.43,
    y2: 284.16,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.79,
    y1: 288.37,
    x2: 207.94,
    y2: 288.37,
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 148.72,
    y: 110.24,
    width: 272,
    height: 207.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.51,422.68s-.47,2.11-5.84,4.91-11.44,6.77-8.41,8.4,13.78-2.1,16.82-4.9,6.53-4.44,6.53-6.77-2.8-3.74-5.13-3.74A4,4,0,0,0,93.51,422.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.18,411.48c-1.4,4.2-5.14,6.53-5.14,7.7a25.11,25.11,0,0,0,.47,3.5,19.75,19.75,0,0,0,5.37,2.11c2.57.46,3.73-.47,3.73-.47s2.81-2.1,3.51-2.8,2.57-1.87,2.33-4.21-1.17-3.27-.23-5.37S129,377.62,129,377.62l-16.34-6.31S99.58,407.27,98.18,411.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,426.42s14.71,6.77,14.95,8.41-10.28,1.86-14.95,1.4-7.7-4.44-7.7-4.44S170.33,425.72,176.4,426.42Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.92,371.78s6.07,37.83,8.41,45.07-.71,6.53.46,8.64a55,55,0,0,0,4.91,6.3s4.2-3.74,6.07-4,3.27-.47,3.27-.47-.94-4.67-1.64-5.6-1.17-4.2-1.87-6.77-1.86-45.07-1.86-45.07S159.82,372.25,154.92,371.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,213.23a86.66,86.66,0,0,0-9.11,7.47c-5.6,5.14-14.94,12.61-15.41,14.25s6.31,32.22,8.88,42,3.27,54.87,0,70.28a186,186,0,0,1-8.64,28.49,40.18,40.18,0,0,0,24.51,7c14.48-.71,21-4.67,28.26-4s15.41.46,19.15-4.44,7.7-6.77,10-9.81a11.83,11.83,0,0,0,2.33-6.54s-2.1-7.94-9.81-32.92-7.7-58.38-9.1-65.38-4.67-28.25-7.94-34.09S147,215.33,140.44,214.17,132.74,212.06,130.4,213.23Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.11,
    y: 211.83,
    width: 0.64,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.58,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.77,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.96,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.14,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.33,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.52,
    y: 211.83,
    width: 3.54,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.7,
    y: 211.83,
    width: 0.68,
    height: 176.06,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,215.81c30.57.22,60.46.22,91.07.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,217.77c30.57.13,60.46.13,91.07.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,226c30.57.28,60.46.28,91.07.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,228c30.57.19,60.46.19,91.07.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,236.25c30.57.33,60.46.33,91.07.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,238.21c30.57.24,60.46.24,91.07.14",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,246.47c30.57.39,60.46.39,91.07.22",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,248.44c30.57.28,60.46.28,91.07.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,256.69c30.57.44,60.46.44,91.07.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,258.66c30.57.34,60.46.34,91.07.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,266.91c29.64-.44,60.46-.44,90.43-.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,268.88c30.57.39,60.46.39,91.07.22",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,277.13c30.57-.39,60.46-.39,91.07-.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,279.1c30.57.45,60.46.45,91.07.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,287.35c30.57-.33,60.46-.33,91.07-.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,289.32c30.57-.43,60.46-.43,91.07-.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,297.58c30.57-.29,60.46-.29,91.07-.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,299.54c30.57-.38,60.46-.38,91.07-.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,307.8c30.57-.23,60.46-.23,91.07-.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,309.76c30.57-.32,60.46-.32,91.07-.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,318c30.57-.18,60.46-.18,91.07-.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,320c30.57-.27,60.46-.27,91.07-.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,328.24c30.57-.12,60.46-.12,91.07-.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,330.2c30.57-.22,60.46-.22,91.07-.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,338.46c30.57-.07,60.46-.07,91.07,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,340.43c30.57-.17,60.46-.17,91.07-.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,348.68c30.57,0,60.46,0,91.07,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,350.65c30.57-.12,60.46-.12,91.07-.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,358.9c30.57,0,60.46,0,91.07,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,360.87c30.57-.06,60.46-.06,91.07,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,369.12c30.57.09,60.46.09,91.07.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,371.09H192.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,379.34c30.57.15,60.46.15,91.07.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,381.31c30.57,0,60.46,0,91.07,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.78,273l.63,3.73s-12.77.32-15.57.32h-4.36l1.25,18.68s1.55,13.38,3.11,31.75-4,44.52-4,47.64-3.11,6.54,4.36,8.09,17.44,1.25,19-2.8,7.79-37.05,6.54-29.89-7.47,32.07-3.11,33.31,15.88-3.42,23.35-3.11,14-2.18,14.63-5.29-3.74-31.76-3.74-31.76l9.34,25.84s1.25,1.56-5,9-34.24,10-49.19,10-33.31-10.89-33.31-10.89,16.19-26.78,13.07-49.19-2.8-62-2.8-62,8.41,2.49,14.32,2.49S136.78,273,136.78,273Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,236.14l7,42.64s7.26-.78,10-3.14,3.92-9.42,3.92-9.42L163,233.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,213.23a86.66,86.66,0,0,0-9.11,7.47c-5.6,5.14-14.94,12.61-15.41,14.25s6.31,32.22,8.88,42,3.27,54.87,0,70.28a186,186,0,0,1-8.64,28.49,40.18,40.18,0,0,0,24.51,7c14.48-.71,21-4.67,28.26-4s15.41.46,19.15-4.44,7.7-6.77,10-9.81a11.83,11.83,0,0,0,2.33-6.54s-2.1-7.94-9.81-32.92-7.7-58.38-9.1-65.38-4.67-28.25-7.94-34.09S147,215.33,140.44,214.17,132.74,212.06,130.4,213.23Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,239.3l13.23,18.63,7.76-23.57s-.54-10.16-4.48-13.72-8.34-8.82-14.92-4.18-5.37,10.74-5.07,14S131.55,239.3,131.55,239.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.42 231.97 140.3 236.45 139.41 250.18 144.78 257.93 148.36 248.09 143.58 236.45 144.18 229.29 139.41 225.11 136.42 231.97",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93,230.28l-8.38,9s-4.35-13.53-5-18.2.8-5.64,3.22-7.09,6.22-.83,9.18-.16,4.52,1.93,5.16,3.22,7.57,18.21,7.57,18.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.84,255c5.51,28.17,12.19,76.38,5.95,123.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.66,
    cy: 265.56,
    r: 1.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.65,
    cy: 297.05,
    r: 1.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,206.85s2.49,5.23,2.73,8.44,8.09,14.86,10.82,14.86,2.62-8.8,2.26-12.72.71-6.07,1.07-6.54-5-1.9-8.32-4.4-6.07-2.86-7.38-2.38S125.61,206.85,125.61,206.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.17,206.49c-3.33-2.5-6.07-2.86-7.38-2.38s-1.18,2.74-1.18,2.74,2.49,5.23,2.73,8.44a.52.52,0,0,0,0,.11,25.51,25.51,0,0,0,6.94,1.43,19.07,19.07,0,0,0,6.07-.45c-.1-3.25.8-5.06,1.12-5.49S137.5,209,134.17,206.49Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17,206.49c-3.33-2.5-6.07-2.86-7.38-2.38s-1.18,2.74-1.18,2.74,2.49,5.23,2.73,8.44a.52.52,0,0,0,0,.11,25.51,25.51,0,0,0,6.94,1.43,19.07,19.07,0,0,0,6.07-.45c-.1-3.25.8-5.06,1.12-5.49S137.5,209,134.17,206.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,206.85s2.49,5.23,2.73,8.44,8.09,14.86,10.82,14.86,2.62-8.8,2.26-12.72.71-6.07,1.07-6.54-5-1.9-8.32-4.4-6.07-2.86-7.38-2.38S125.61,206.85,125.61,206.85Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14,203.63s3.92,4.05,6.06,4.52,3.69-1.19,2.85-2.85-.35-4.16,2.14-3.81,4.52-1.78,3.69-4.63-2.14-5.59-5.23-5S117.16,198.28,120.14,203.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,187.82s1.9,4.16,3.68,5.83,3.33,1.3,2.74,2.61-3.21,3-3.21,3,.24,5.94,0,8.79,0,3.69-2.62,4.17A22.5,22.5,0,0,1,136,211a9.81,9.81,0,0,1-5.47-4.4,11.81,11.81,0,0,1-3.33-.36c-2.26-.47-4.16-5.23-2.85-7a3.48,3.48,0,0,1,4.87-.6c.84,1,1.79,1.9,2.5,1.9s2.14-.59,1.31-2.14-1.79-2.85-.48-3.92S143.92,187.7,146.06,187.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.06,187.82c-2.14-.12-12.25,5.59-13.56,6.66s-.35,2.38.48,3.92-.6,2.14-1.31,2.14-1.66-.95-2.5-1.9a3.48,3.48,0,0,0-4.87.6c-1.31,1.78.59,6.54,2.85,7,.26.06.51.1.74.14a97.31,97.31,0,0,1,20.68-14.13A32.6,32.6,0,0,1,146.06,187.82Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,187.82c-2.14-.12-12.25,5.59-13.56,6.66s-.35,2.38.48,3.92-.6,2.14-1.31,2.14-1.66-.95-2.5-1.9a3.48,3.48,0,0,0-4.87.6c-1.31,1.78.59,6.54,2.85,7,.26.06.51.1.74.14a97.31,97.31,0,0,1,20.68-14.13A32.6,32.6,0,0,1,146.06,187.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,187.82s1.9,4.16,3.68,5.83,3.33,1.3,2.74,2.61-3.21,3-3.21,3,.24,5.94,0,8.79,0,3.69-2.62,4.17A22.5,22.5,0,0,1,136,211a9.81,9.81,0,0,1-5.47-4.4,11.81,11.81,0,0,1-3.33-.36c-2.26-.47-4.16-5.23-2.85-7a3.48,3.48,0,0,1,4.87-.6c.84,1,1.79,1.9,2.5,1.9s2.14-.59,1.31-2.14-1.79-2.85-.48-3.92S143.92,187.7,146.06,187.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,199.24A8.22,8.22,0,0,0,144,202.8c-1.88,3,0,3.51,1.17,2.8s3.27-2.33,4.44-3S151.07,199,149.27,199.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.73,
    cy: 194.22,
    rx: 0.71,
    ry: 1.65,
    transform: "translate(-59.72 63.89) rotate(-20.85)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,191.85a4.64,4.64,0,0,1,4.37-.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,212.55a51,51,0,0,1,9.52-13.31c6.54-6.66,31-13.56,32.34-15.46s-11.3,1.19-11.3,1.19-7.37-8.92-18.07-9.52-13.79,11.06-13.91,16.89,2.85,12.6,2.85,12.6S114.07,213.5,116,212.55Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 171.2,
    width: 3.54,
    height: 49.5,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.58,
    y: 171.2,
    width: 3.54,
    height: 49.5,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.77,
    y: 171.2,
    width: 3.54,
    height: 49.5,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.96,
    y: 171.2,
    width: 3.54,
    height: 49.5,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.14,
    y: 171.2,
    width: 3.54,
    height: 49.5,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,178.61q27.42,0,54.84-.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,180.51q27.42,0,54.84-.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,188.87q27.42,0,54.84-.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,190.77q27.42,0,54.84-.14",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,199.13q27.42,0,54.84-.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,201q27.42,0,54.84-.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,209.39q27.42,0,54.84-.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,211.28q27.42,0,54.84-.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21,219.65q27.42,0,54.84-.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116,212.55a51,51,0,0,1,9.52-13.31c6.54-6.66,31-13.56,32.34-15.46s-11.3,1.19-11.3,1.19-7.37-8.92-18.07-9.52-13.79,11.06-13.91,16.89,2.85,12.6,2.85,12.6S114.07,213.5,116,212.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,204.94s-3.33,8.56-1.43,7.61a51,51,0,0,1,9.52-13.31c6.54-6.66,31-13.56,32.34-15.46s-11.3,1.19-11.3,1.19-8.44,4.4-15.45,9A117.33,117.33,0,0,0,117.4,204.94Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.49,178.07s.12,11.53,8.68,17.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,289l3.64,1s6.29-4.39,7-4.52,6.66,3.27,8.55,4.78,4.27,3.14,3.64,3.64-2-.13-2.89-.63-6.28-3.14-6.28-3.14,4,2.64,5.4,3.77,3.39,1.76,2.89,2.39a1.67,1.67,0,0,1-2.39.5c-1.25-.63-7.66-4.27-7.66-4.27s5.4,3.64,6.41,4.52,1,2.14-.13,2.14-4.27-1.64-5.4-2.26-4.4-2.27-4.4-2.27a46.61,46.61,0,0,1,3.89,4.9c.76,1.39,1.89,3.15.63,3.15s-3-2.89-3.89-3.9-4.15-2.14-4.15-2.14a23,23,0,0,1-4.77,1.64c-2.14.37-6.41-4.15-6.41-4.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.32,
    y1: 290.04,
    x2: 118.21,
    y2: 293.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.62,
    y1: 292.56,
    x2: 127.61,
    y2: 291.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.38,
    y1: 290.17,
    x2: 129.12,
    y2: 288.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.07,247.32S74.13,259.7,73.89,260.63s37.83,36.2,37.83,36.2l7-7.71L97.94,261.33l15.88-10s1.4-7.7-.93-12.14a10.28,10.28,0,0,0-7-5.14Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.75,
    y: 229.11,
    width: 1.44,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.02,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.21,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.58,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.77,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.96,
    y: 229.11,
    width: 3.54,
    height: 75.19,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,236.46c27.57.12,55.59.12,83.15-.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,238.36c27.57.09,55.59.09,83.15-.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,246.71c27.57.15,55.59.15,83.15-.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,248.62c27.57.1,55.59.1,83.15-.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,257c27.57.16,55.59.16,83.15-.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,258.87c27.57.13,55.59.13,83.15-.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.37,250.59s7.47,4.67,10.58,5.92,9.34,4.05,9.34,4.05l7.16-3.74-16.81-13.7Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,266.64c27.57-.17,55.59-.17,83.15.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,269.13c27.57.14,55.59.14,83.15-.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,276.89c27.57-.15,55.59-.15,83.15.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,279.38c27.57.17,55.59.17,83.15-.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,287.14c27.57-.12,55.59-.12,83.15.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,289.05c27.57-.16,55.59-.16,83.15.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,297.4c27.57-.11,55.59-.11,83.15.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,299.3c27.57-.14,55.59-.14,83.15.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.07,247.32S74.13,259.7,73.89,260.63s37.83,36.2,37.83,36.2l7-7.71L97.94,261.33l15.88-10s1.4-7.7-.93-12.14a10.28,10.28,0,0,0-7-5.14Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.45,246.82s-14.57-8.3-20.61-14.2-8.54-8.67-9.17-6.41,5.28,32,6.41,32.54,25,9.05,29.78,9.3,8,.63,8.55-1.5-3-8.67-7.42-13.83S193.45,246.82,193.45,246.82Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.14,
    y: 235.18,
    width: 3.54,
    height: 39.7,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.33,
    y: 235.18,
    width: 3.54,
    height: 39.7,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.52,
    y: 235.18,
    width: 3.54,
    height: 39.7,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.7,
    y: 235.18,
    width: 3.54,
    height: 39.7,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.89,
    y: 235.18,
    width: 3.54,
    height: 39.7,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,238.21q26,.28,51.92.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,246.47q26,.47,51.92.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,248.44q26,.34,51.92.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,256.69q26,.53,51.92.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,258.66q26,.4,51.92.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,264.6s9.65-3.11,12.77-8.09,1.87-8.1-.94-11.52a10.3,10.3,0,0,0-6.53-3.74s-1.56,11.52-5.3,13.7a44.29,44.29,0,0,0-7.47,5.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,266.91q26-.53,51.92-.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,268.88q26,.47,51.92.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.45,246.82s-14.57-8.3-20.61-14.2-8.54-8.67-9.17-6.41,5.28,32,6.41,32.54,25,9.05,29.78,9.3,8,.63,8.55-1.5-3-8.67-7.42-13.83S193.45,246.82,193.45,246.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.13,216.27s6.54,20.08,9.34,33.86,4,26.61,4,26.61-4-2.56-14.71-3.5-15.64-2.57-20.31-11.44-7.71-8.17-12.38-9.57-6.07-4-6.07-4S125.5,216,127.13,216.27Zm14.8-1.75a126.47,126.47,0,0,1,8.42,21.62c3.64,12.56,8.8,40,8.8,40s8.92-1,11.56-6.66,2.76-7.8,7-9.3,10.06-4.65,10.56-8.67a63.2,63.2,0,0,1,1.63-8.05s-23.49-19.47-27.14-22S142.94,213.52,141.93,214.52Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 228.56,
    width: 3.54,
    height: 67.2,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.02,
    y: 228.56,
    width: 3.54,
    height: 67.2,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.21,
    y: 228.56,
    width: 3.54,
    height: 67.2,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.58,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.77,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.96,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.14,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.33,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.52,
    y: 207.11,
    width: 3.54,
    height: 88.66,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,215.81c29,.22,57.94.22,86.54.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,217.77c29,.13,57.94.13,86.54.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,226c29,.28,57.94.28,86.54.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,228c29,.19,57.94.19,86.54.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,236.25c40.17.33,80.33.33,120.82.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,238.21c40.17.24,80.33.24,120.82.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,246.47c40.17.39,80.33.39,120.82.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,248.44c40.17.28,80.33.28,120.82.14",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,256.69c40.17.44,80.33.44,120.82.22",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,258.66c40.17.34,80.33.34,120.82.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,266.91c40.17-.44,80.33-.44,120.82-.22",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,268.88c40.17.39,80.33.39,120.82.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,277.13c40.17-.39,80.33-.39,120.82-.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,279.1c40.17.45,80.33.45,120.82.23",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,287.35c40.17-.33,80.33-.33,120.82-.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,289.32c40.17-.43,80.33-.43,120.82-.22",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.13,216.27s6.54,20.08,9.34,33.86,4,26.61,4,26.61-4-2.56-14.71-3.5-15.64-2.57-20.31-11.44-7.71-8.17-12.38-9.57-6.07-4-6.07-4S125.5,216,127.13,216.27Zm14.8-1.75a126.47,126.47,0,0,1,8.42,21.62c3.64,12.56,8.8,40,8.8,40s8.92-1,11.56-6.66,2.76-7.8,7-9.3,10.06-4.65,10.56-8.67a63.2,63.2,0,0,1,1.63-8.05s-23.49-19.47-27.14-22S142.94,213.52,141.93,214.52Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.72,213.81s.94,5.58,1.26,6.91,3.37,5.19,3.37,5.19l-5.1,3.22a67.06,67.06,0,0,0-4-6.36c-.86-.87-5.18-2-6.44-3.7s-.94-3.69-1.26-4.95-3.22-4.87-2.51-5.42,2.2-.08,2.9.79.71,2.12,1,2.75,4.16,3,4.16,3-1.73-4.95-2-5.65a1.38,1.38,0,0,1,1.1-1.81c.78,0,4.32,3.46,4.32,3.46Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.78,
    cy: 194.08,
    rx: 6.23,
    ry: 11.36,
    transform: "translate(-69.59 93.23) rotate(-26.55)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.31,
    cy: 194.32,
    rx: 4.28,
    ry: 9.61,
    transform: "translate(-69.74 93.04) rotate(-26.55)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,203.85l8.83,13.2a1.49,1.49,0,0,0,2.14.37h0a1.5,1.5,0,0,0,.29-2.12L169,202.8a.7.7,0,0,0-1-.15l-.33.22A.71.71,0,0,0,167.55,203.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,205.7s-2.62,1.62-2.5,2.5.5,1.24,1.25,1.24,2.74-1.12,3.49-1.49S176.45,204.71,174,205.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,208.7a30.42,30.42,0,0,0-2.51,3.93c-.08.55,4.47,5,5.26,5s5.11-2.67,4.95-3.77-4.56-4.4-5.34-5.19S175.88,207.6,175,208.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.84,
    y1: 214.2,
    x2: 178.08,
    y2: 209.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.44,
    y1: 211.61,
    x2: 176.2,
    y2: 216.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,255.49l-12.94-27.14,9.55-5s10.18,11.81,14.33,20,6,21.24,4.4,23.25-8.93.62-12.57-1.64",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.33,
    y: 218.84,
    width: 3.54,
    height: 54.64,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.52,
    y: 218.84,
    width: 3.54,
    height: 54.64,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.7,
    y: 218.84,
    width: 3.54,
    height: 54.64,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.89,
    y: 218.84,
    width: 3.54,
    height: 54.64,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,226c17,.28,34.7.28,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,228c17,.19,34.7.19,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,236.25c17,.33,34.7.33,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,238.21c17,.24,34.7.24,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,246.47c17,.39,34.7.39,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,248.44c17,.28,34.7.28,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,256.69c17,.44,34.7.44,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,258.66c17,.34,34.7.34,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,266.91c17-.44,34.7-.44,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,268.88c17,.39,34.7.39,51.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,255.49l-12.94-27.14,9.55-5s10.18,11.81,14.33,20,6,21.24,4.4,23.25-8.93.62-12.57-1.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresult);
export default __webpack_public_path__ + "static/media/No result.b7ec81243afc55d46db8f99a5435e452.svg";
export { ForwardRef as ReactComponent };